__turbopack_context__.v({
  "charsLimit": "Input-module__BxY-JW__charsLimit",
  "charsLimitText": "Input-module__BxY-JW__charsLimitText",
  "container": "Input-module__BxY-JW__container",
  "content": "Input-module__BxY-JW__content",
  "errorMessage": "Input-module__BxY-JW__errorMessage",
  "label": "Input-module__BxY-JW__label",
  "labelOptional": "Input-module__BxY-JW__labelOptional",
  "labelRequired": "Input-module__BxY-JW__labelRequired",
  "labelSuffix": "Input-module__BxY-JW__labelSuffix",
});
